import {observer} from 'mobx-react-lite';
import React from 'react';

import {Close} from '_/assets/images';

import {NotificationProps} from '..';
import {ExclamationMark, HeaderRow, TextWrapper} from '../styles';

const UInformativeEntity = ({
  notification,
  action,
  Icon,
}: NotificationProps): React.ReactElement => (
  <div>
    <HeaderRow>
      {Icon || <Close />}
      <ExclamationMark show={notification.importantFlag} />
      <TextWrapper>{notification.message}</TextWrapper>
    </HeaderRow>
    {action ? <div>{action}</div> : null}
  </div>
);

export default observer(UInformativeEntity);
